export const INVALID_VALUES = ['', null, undefined, '0', 'N/A'];
